var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shen"},[_c('main',[_c('van-icon',{attrs:{"name":"passed"}}),_c('h2',[_vm._v("注册成功，正在审核")]),_c('van-button',{staticStyle:{"width":"80%"},attrs:{"type":"danger"},on:{"click":function($event){return _vm.go()}}},[_vm._v("返回登录")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }